import Http from '@/Http/Request';
import { useMutation } from 'react-query';
import { CreateModulePayload } from './types';


const createModule = async (payload: CreateModulePayload) => {
	
	const { data } = await Http({
		method: 'POST',
		url: 'addModuleApi',
		data: {
			name: payload.name,
			shortName: payload.shortName,
			remark: payload.remark || ''
		},
	});
	return data;
};

const useCreateModule = () => {
	const { mutate } = useMutation<
		CreateModulePayload,
		Error,
		CreateModulePayload
	>({
		mutationKey: ['createModule'],
		mutationFn: (payload: CreateModulePayload) =>
			createModule({ name: payload.name, shortName: payload.shortName, remark: payload.remark }),
	});

	return {
		mutate,
	};
};

export default useCreateModule;
